var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSyncIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 333,
    height: 360,
    viewBox: "0 0 333 360",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M238 0C231.6 0 225.2 2.4 220.3 7.3C210.5 17.1 210.5 32.9 220.3 42.7L244.6 67H25C11.2 67 0 78.2 0 92C0 105.8 11.2 117 25 117H244.6L220.3 141.3C210.5 151.1 210.5 166.9 220.3 176.7C230.1 186.5 245.9 186.5 255.7 176.7L325.7 106.7C335.5 96.9 335.5 81.1 325.7 71.3L255.7 7.3C250.8 2.4 244.4 0 238 0Z",
    fill: "#1450ff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M95 360C101.4 360 107.8 357.6 112.7 352.7C122.5 342.9 122.5 327.1 112.7 317.3L88.4 293H308C321.8 293 333 281.8 333 268C333 254.2 321.8 243 308 243H88.4L112.7 218.7C122.5 208.9 122.5 193.1 112.7 183.3C102.9 173.5 87.1 173.5 77.3 183.3L7.3 253.3C-2.5 263.1 -2.5 278.9 7.3 288.7L77.3 352.7C82.2 357.6 88.6 360 95 360Z",
    fill: "#1450ff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyncIcon);
export default __webpack_public_path__ + "static/media/sync_icon.eaac8e5660e27ded667c015faab743da.svg";
export { ForwardRef as ReactComponent };